import { ChainId, ChainName } from '@ui/types/chain';
import { create } from 'zustand';

export type TradeFlowKey = string;
// Placeholder for the value. You can refine this later.
export type TradeFlowValue = {
  chainId: ChainId;
  chainName: ChainName;
  tradeKey: string;
  marketTradeReceiptSent: string; // ISO date string
  matchedPositionId?: string; // Optional, can be undefined
  positionListShowedAt?: string; // Optional, can be undefined
  marketReceiptToListGapSeconds?: number; // Optional, can be undefined
  openMarketTradeEventReceivedAt?: string; // Optional, can be undefined
};

type TradeFlowCheckerState = {
  byKey: Record<TradeFlowKey, TradeFlowValue>;
  setValue: (key: TradeFlowKey, value: TradeFlowValue) => void;
  getValue: (key: TradeFlowKey) => TradeFlowValue | undefined;
  remove: (key: TradeFlowKey) => void;
  clear: () => void;
};

export const TradeFlowCheckerStore = create<TradeFlowCheckerState>(
  (set, get) => ({
    byKey: {},
    setValue: (key, value) =>
      set((state) => ({
        byKey: { ...state.byKey, [key]: value },
      })),
    getValue: (key) => get().byKey[key],
    remove: (key) =>
      set((state) => {
        const { [key]: _, ...rest } = state.byKey;

        return { byKey: rest };
      }),
    clear: () => set({ byKey: {} }),
  }),
);
